<template>
    <v-app class="login-page">
        <v-main class="login-wrapper">

            <!-- Left Pane (Desktop Only) -->
            <div class="login-left">
                <img src="@/assets/image.png" class="bg-image" />
                <img src="@/assets/crowdital_icon.png" class="logo" />
            </div>

            <!-- Right Pane -->
            <div class="login-right">
                <div class="login-form">

                    <!-- Header -->
                    <div class="mb-8">
                        <img src="../assets/crowdital_logo_dark.png" class="logo-img" alt="Crowdital Logo" />
                        <h3 class="text-2xl font-semibold text-gray-900 mt-8">
                            Create your transaction Pin
                        </h3>
                        <p class="text-gray-400 text-xs mt-2">

                        </p>
                    </div>

                    <div v-if="error" class="text-red text-sm mt-2 mb-6">
                        {{ error }}
                    </div>

                    <!-- Form -->
                    <form @submit.prevent="submitPin" class="w-full space-y-6">

                        <!-- PIN -->
                        <div class="pin-wrapper">
                            <div class="pin-container pin">
                                <input v-for="(digit, index) in pin" :key="'p' + index" v-model="pin[index]"
                                    type="password" maxlength="1" class="pin-box"
                                    @input="handleInput($event, index, 'pin')"
                                    @keydown="handleKeydown($event, index, 'pin')" />
                            </div>
                        </div>

                        <!-- CONFIRM PIN -->
                        <div class="pin-wrapper">
                            <div class="pin-container confirmPin mt-4 mb-6">
                                <input v-for="(digit, index) in confirmPin" :key="'c' + index"
                                    v-model="confirmPin[index]" type="password" maxlength="1" class="pin-box"
                                    @input="handleInput($event, index, 'confirmPin')"
                                    @keydown="handleKeydown($event, index, 'confirmPin')" />
                            </div>
                        </div>

                        <!-- Submit -->
                        <button type="submit" :disabled="loading" class="login-button mb-4">
                            <span v-if="!loading">Complete Registration <v-icon start>mdi-account-check-outline</v-icon></span>
                            <span v-else>Completing Registration <v-icon start class="spin">mdi-loading</v-icon></span>
                        </button>
                        <p>Or, return to
                            <button type="button" @click="signin"
                                class="text-sm font-medium text-green hover:text-black transition-colors">
                                Login
                            </button>
                        </p>
                    </form>
                    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" location="top right"> {{ snackbar.message }}
                        <template #actions>
                            <v-btn variant="text" @click="snackbar.show = false">
                            Close
                            </v-btn>
                        </template>
                    </v-snackbar>

                </div>
            </div>

        </v-main>
    </v-app>
</template>

<script setup>
import { ref, onMounted, watch } from "vue"
import { useRouter, useRoute } from "vue-router"
import { addpin } from "@/api/auth"
import { getAllErrors } from "@/util"
//import { useUserStore } from "@/store/user"

const router = useRouter()
const route = useRoute()
//const user = useUserStore()

const pin = ref(["", "", "", "", "", ""])
const confirmPin = ref(["", "", "", "", "", ""])
const error = ref("")
const loading = ref(false)


//Snack bar
const snackbar = ref({
    show: false,
    message: "",
    color: "success" // success | error | warning | info
})

const showSnackbar = (message, color = "success") => {
    snackbar.value.message = message
    snackbar.value.color = color
    snackbar.value.show = true
}


const submitPin = async () => {

    if (!validatePin()) return //
    const firstPin = pin.value.join("")
    const secondPin = confirmPin.value.join("")

    //error.value = ""

    if (firstPin.length !== 6 || secondPin.length !== 6) {
        error.value = "Please complete both PIN fields"
        return
    }

    if (firstPin !== secondPin) {
        error.value = "PINs do not match"
        return
    }

    loading.value = true
    try {
        await addpin({
            email: route.query.email,
            pin: pin.value.join("")
        })
        // SUCCESS MESSAGE
        showSnackbar("Pin Created Succesfully", "success")
        setTimeout(() => {
            router.push({ name: "Login" })
        }, 1000);
    } catch (e) {
        const msg = getAllErrors(e)
        //console.log(e.response?.data)
        showSnackbar(
            msg || "Pin Creation failed",
            "error"
        )
       // error.value = e.response?.data?.errors || "Login failed"; //e.message || "Invalid credentials"
    } finally {
        loading.value = false
    }
}


//Mobile style like pin creation
const getBoxes = (type) => {
  return document.querySelectorAll(`.${type} .pin-box`)
}

const handleInput = (e, index, type) => {
  const value = e.target.value.replace(/\D/g, "")

  const arr = type === "pin" ? pin : confirmPin
  arr.value[index] = value

  // move forward
  if (value && index < arr.value.length - 1) {
    const boxes = getBoxes(type)
    boxes[index + 1]?.focus()
  }
}

const handleKeydown = (e, index, type) => {
  const arr = type === "pin" ? pin : confirmPin
  const boxes = getBoxes(type)

  // BACKSPACE FIX
  if (e.key === "Backspace") {
    e.preventDefault()

    if (arr.value[index]) {
      // clear current
      arr.value[index] = ""
    } else if (index > 0) {
      // move back
      boxes[index - 1]?.focus()
      arr.value[index - 1] = ""
    }
  }

  // LEFT ARROW
  if (e.key === "ArrowLeft" && index > 0) {
    boxes[index - 1]?.focus()
  }

  // RIGHT ARROW
  if (e.key === "ArrowRight" && index < arr.value.length - 1) {
    boxes[index + 1]?.focus()
  }
}

const validatePin = () => {
  const p1 = pin.value.join("")
  const p2 = confirmPin.value.join("")

  if (p1.length < 4 || p2.length < 4) {
    error.value = "Enter complete PIN"
    return false
  }

  if (p1 !== p2) {
    error.value = "PINs do not match"
    return false
  }

  error.value = ""
  return true
}

onMounted(() => {
   document.querySelector(".pin .pin-box")?.focus()
})

watch([pin, confirmPin], () => {
  validatePin()
}, { deep: true })

const signin = () => {
    router.push("/login")
}
</script>

<style scoped>
/* Layout */
.login-wrapper {
    display: flex;
    min-height: 100vh;
}

.login-left {
    flex: 1;
    position: relative;
    overflow: hidden;
}

.bg-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.logo-img {
    width: 20em;
}

.logo {
    position: absolute;
    bottom: 24px;
    left: 24px;
    width: 130px;
}

.login-right {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f9fafb;
    padding: 24px;
}

.login-form {
    width: 100%;
    max-width: 420px;
}

/* Inputs */
.modern-input {
    width: 100%;
    height: 46px;
    margin-top: 6px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid #d1d5db;
    font-size: 15px;
    background: transparent;
    transition: all 0.2s ease;
}

.modern-input:focus {
    outline: none;
    border-color: #000;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
}

/* Button */
.login-button {
    width: 100%;
    height: 46px;
    background: #000;
    color: #fff;
    border-radius: 10px;
    font-weight: 600;
    transition: all 0.25s ease;
}

.login-button:hover {
    background: #292828;
}

.login-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.spacing {
    margin-bottom: 1em;
}

.m-space {
    margin-left: 9.5rem !important;
}

.modern-input.pr-10 {
    padding-right: 2.5rem;
    /* enough space for eye button */
}

.relative {
    position: relative;
}

/* Button positioned over the input */
.absolute {
    position: absolute;
    cursor: pointer;
}

.pin-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.pin-container {
  display: flex;
  gap: 10px;
  justify-content: center;
  width: 100%;
  max-width: 280px; /* 🔥 prevents overflow */
}

.pin-box {
  max-width: 60px;
  height: 60px;
  text-align: center;
  font-size: 20px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  outline: none;
  transition: all 0.2s ease;
}

/* focus state */
.pin-box:focus {
  border-color: #000;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}
.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Mobile */
@media (max-width: 480px) {
    .login-wrapper {
        flex-direction: column;
    }

    .login-left {
        display: none;
    }

    .m-space {
        margin-left: 7rem !important;
    }
    .pin-container {
    max-width: 280px;
    gap: 8px;
  }

  /* .pin-box {
    max-width: 45px;
    height: 45px;
    font-size: 18px;
  }  */
  .pin-box {
    max-width: 48px;
    height: 48px;
    text-align: center;
    font-size: 20px;
    border-radius: 10px;
    border: 1px solid #d1d5db;
    outline: none;
    transition: all 0.2s ease;
    }
   
}
</style>
